import React from 'react';
import {IProps} from './types';
import * as S from './styles';
import BackgroundFileBar from '@routes/private/Templates/components/NewTemplate/components/BackgroundFileBar';

const BackgroundContainer:React.FC<IProps> = (props) => {

  return (
    <S.Root >
      {
        props.isLoading ? 
        <S.EmptyContainer>
            Saving templates...  
        </S.EmptyContainer>
        : props.files?.length > 0 ?
          props.files.map((newFile:any, index:number) => {
            return (
              <BackgroundFileBar 
                key={index}
                newFile={newFile}
                fileProgress={props.filesProgress[index]}
              />
            )
          })
        :
          <S.EmptyContainer>
            Upload .psd files to see their progress here    
          </S.EmptyContainer>
      }
    </S.Root >
  );
}

export default BackgroundContainer;